import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import Edit from "@material-ui/icons/Edit";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from "axios";
import Button from "components/CustomButtons/Button.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { api_url } from "redux/config.js";
import Toast from "views/Toast/Toast";
import { TransReactTable } from "components/CustomReactTable/TransReactTable";
import { withTranslation } from "react-i18next";


const styles = {
  ...regularFormsStyle,
  ...extendedFormsStyle
};

class EmailListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showactive: "active",
      emaillistData: [],
      active: "pendingTransaction",
      data: [],

      loading: false,
      pages: -1,
      paginationState: null
    };
  }
  componentDidMount() { }
  toggleActivateStateOfSurvey = item => {
    const newActive = !item.active;
    this.props.dispatch({ type: "LOAD_START" });
    const activate_term = newActive ? "emaillist/activate" : "emaillist/deactivate";
    axios({
      url: api_url + activate_term,
      method: "post",
      data: {
        id: item.id,
        active: newActive
      },
      headers: {
        authorization: "Bearer " + this.props.user.token
      }
    })
      .then(res => {
        if (res.data.success) {
          const newData = this.state.data.map(ditem => {
            let newitem = ditem;
            if (ditem.id === item.id) {
              newitem.active = newActive;
            }
            return newitem;
          });

          this.setState({
            data: newData
          });
          this.normalizeData(newData);
        } else {
          Toast(400, res.data.error);
        }
      })
      .finally(this.props.dispatch({ type: "LOAD_END" }));
  };
  normalizeData = data => {
    const { classes, t } = this.props;

    if (!data || data.length === 0) {
      this.setState({
        emaillistData: []
      });
    }
    const ndata = data.map((item, key) => {
      const edit_url = "/email_list/edit_email_list/" + item.id;
      const action = (
        <div key={key}>

          <Button
            justIcon
            size="sm"
            color="info"
            onClick={() => this.props.history.push(edit_url)}
          >
            <Edit />
          </Button>


        </div>
      );
      const active = (
        <Switch
          checked={item.active}
          onChange={e => {
            this.toggleActivateStateOfSurvey(item);
          }}
          value="checkedA"
          color="primary"
          classes={{
            switchBase: classes.switchBase,
            checked: classes.switchChecked,
            icon: classes.switchIcon,
            iconChecked: classes.switchIconChecked,
            bar: classes.switchBar
          }}
        />
      );
      // A phone list is marked so the two kinds are never confused at a glance — the campaign form
      // offers each channel only its own kind, so picking the wrong one here is a dead end.
      const isPhone = item.kind === 'phone';
      const kind = (
        <span style={{
          fontSize: 11, fontWeight: 700, letterSpacing: '.05em', padding: '3px 9px', borderRadius: 99,
          background: isPhone ? '#e8f1fb' : '#e7f4ea', color: isPhone ? '#245b96' : '#2f8a45',
          whiteSpace: 'nowrap',
        }}>
          {isPhone ? t('Phone') : t('Email')}
        </span>
      );
      return {
        name: item.name,
        kind,
        date: moment(item.updated_at).format("MMMM Do YYYY, h:mm:ss a"),
        total_emails: item.emails.length,
        active,
        action
      };
    });
    this.setState({
      emaillistData: ndata
    });
  };
  loadData = state => {
    this.setState({
      paginationState: state
    });
    this.props.dispatch({ type: "LOAD_START" });
    let data = {
      page: state.page,
      pageSize: state.pageSize,
      sorted: state.sorted,
      filtered: state.filtered
    };
    const showactive = state.showactive;
    if (showactive && showactive !== "all") {
      data.active = showactive === "active" ? true : false;
    }
    axios({
      url: api_url + "emaillist/get",
      method: "post",
      headers: {
        authorization: "Bearer ".concat(this.props.user.token)
      },
      data
    })
      .then(res => {
        if (res.data.success) {
          this.normalizeData(res.data.data.rows);
          this.setState({
            data: res.data.data.rows,
            pages: res.data.data.pages,
            loading: false
          });
        } else {
          Toast(400, res.data.error);
        }
      })
      .catch(e => {
        Toast(500);
      })
      .finally(() => {
        this.props.dispatch({ type: "LOAD_END" });
      });
  };
  handleactive = showactive => {
    this.setState({
      showactive
    });
    this.loadData({
      ...this.state.paginationState,
      showactive
    });
  };
  render() {
    const { classes, t } = this.props;

    const column = [
      {
        Header: t("List name"),
        accessor: "name"
      },
      {
        Header: t("Type"),
        accessor: "kind",
        sortable: false,
        maxWidth: 110,
      },
      {
        Header: t("Date"),
        accessor: "date"
      },
      {
        Header: t("Active"),
        accessor: "active",
        sortable: false,
      },
      {
        Header: t("Total E-mails"),
        accessor: "total_emails"
      },
      {
        Header: t("Actions"),
        accessor: "action",
        sortable: false,
        minWidth: 150
      }
    ];
    return (
      <div>
        <GridContainer>
          <GridItem md={12} sm={12}>
            <Button color="info" href="/email_list/create_email_list">
              {t('Create new emaillist')}
            </Button>
            <Button color="primary" href="/email_list/create_email_list?kind=phone">
              {t('Create new phone list')}
            </Button>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.showactive === "all"}
                    tabIndex={-1}
                    onClick={() => this.handleactive("all")}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={t("All")}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.showactive === "active"}
                    tabIndex={-1}
                    onClick={() => this.handleactive("active")}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={t("Active")}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.showactive === "deactive"}
                    tabIndex={-1}
                    onClick={() => this.handleactive("deactive")}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={t("Deactive")}
              />
            </div>
            <TransReactTable
              defaultPageSize={20}
              data={this.state.emaillistData}
              columns={column}
              pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
              loading={this.state.loading}
              manual // informs React Table that you'll be handling sorting and pagination server-side
              onFetchData={(state, instance) => {
                // show the loading overlay
                this.setState({ loading: true });

                this.loadData({...state, showactive: this.state.showactive});
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(EmailListPage)));
